<template lang="pug">
  .notFound.page
    .txt.txtCenter
      span.title 404
      p Página não encontrada
      router-link(to="/").bt.hl 
        ArrowBack.icon
        span voltar ao ínicio
</template>

<script>
import './style.sass'
import ArrowBack from '@/assets/svg/md-arrow-back.svg'

export default {
  name: 'NotFound',
  components: {
    ArrowBack
  },
  methods: {
  },
  mounted () {
    this.$store.commit('setLoading', false)
  }
}
</script>